import * as z from 'zod'
import { NoteListItem, NoteSingleItem } from '../NoteEntity.js'
import { GetApiContract, PutApiContract } from './ApiContract.js'
import { Selectable } from 'kysely'
import { Notes } from '../../db.js'

export interface GetNoteListRequest extends GetApiContract {
    Response: Array<NoteListItem>
    ResponseJson: Array<NoteListItem>
}

export interface GetNoteSingleItemRequest extends GetApiContract {
    Response: NoteSingleItem
    ResponseJson: NoteSingleItem
}

export const putNoteSchema = z
    .object({
        content: z.string().nullable(),
    })
    .and(
        z.union([
            z.object({ convertibleId: z.string() }),
            z.object({ issueId: z.string() }),
            z.object({ warrantId: z.string() }),
        ]),
    )

export interface PutNoteRequest extends PutApiContract {
    Body: z.infer<typeof putNoteSchema>
    Response: Selectable<Notes>
    ResponseJson: Selectable<Notes>
}
